import { Box, Flex, useColorMode, useColorStyle } from '@tonic-one/react';
import React, { useState } from 'react';

export default function DashboardTabs(props: {
  row?: number;
  column?: number;
  height?: string;
  tabs: {
    key: string;
    title: any;
    body: () => JSX.Element;
  }[];
  onTabChange?: (key: string) => void;
}) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const [selectedKey, setSelectedKey] = useState(props.tabs?.[0].key || null);
  const selectedTab = props.tabs.find((tab) => tab.key === selectedKey);

  return (
    <Flex
      gridRow={`auto/span ${props.row || 1}`}
      gridColumn={`auto/span ${props.column || 1}`}
      height={props.height || '718px'}
      direction="column"
      align="stretch"
      justify="flex-start"
    >
      <Flex
        direction="row"
        align="center"
        justify="flex-start"
        height="72px"
        color="transparent"
      >
        {props.tabs.map((tab) => (
          <Box
            p="24px"
            height="100%"
            fontSize="18px"
            color={colorStyle.color.primary}
            background={
              tab.key !== selectedKey
                ? colorMode === 'dark'
                  ? 'transparent'
                  : colorStyle.background.secondary
                : colorMode === 'dark'
                  ? colorStyle.background.tertiary
                  : 'transparent'
            }
            border="1px solid"
            borderBottom={colorMode === 'dark' ? '' : 'none'}
            borderColor={colorStyle.background.tertiary}
            cursor="pointer"
            onClick={() => {
              setSelectedKey(tab.key);
              if (props.onTabChange) {
                props.onTabChange(tab.key);
              }
            }}
          >
            {tab.title}
          </Box>
        ))}
      </Flex>
      <Box
        height="calc(100% - 72px)"
        padding="12px 16px 14px 24px"
        backgroundColor={
          colorMode === 'dark'
            ? colorStyle.background.tertiary
            : colorStyle.background.primary
        }
        color={colorStyle.color.primary}
        border={colorMode === 'dark' ? '' : '1px solid'}
        borderColor={colorMode === 'dark' ? '' : colorStyle.background.tertiary}
      >
        {selectedTab?.body()}
      </Box>
    </Flex>
  );
}
